export const LOCATIONS_ROUTES = {
  __ROOT__: '/locations',
  EDIT_LOCATION: '/locations/edit/:locationId',
  NEW_LOCATION: '/locations/new',
  VIEW_LOCATION: '/locations/view/:locationId',
}

export const LOCATION_DEFAULT_IMAGE_URL =
  'https://therms.s3.us-west-2.amazonaws.com/images/location-placeholder.png'
